import React from "react";
import Subheading from "../Common/Subheading";
import SchedulersIcon from "../../assets/icons/Icon_Library/application icons/general/scheduling.svg2";
import SchedulersList from "./SchedulersList";

function SchedulersPage() {
  return (
    <div className="">
      <div className="d-flex justify-content-between align-items-center">
        <Subheading
          Icon={SchedulersIcon}
          heading="Schedulers"
          subheading="Manage your schedulers"
        />
      </div>
      <SchedulersList />
    </div>
  );
}

export default SchedulersPage;
